export default {
  send: 'Envoyer',
  typeMessage: 'Entrer le message...',
};
